import {
	NUMBER_CF_TYPE,
	STORY_POINTS_TYPE,
	STORY_POINT_ESTIMATE_CF_TYPE,
} from '@atlassian/jira-platform-field-config';
import type { StringValue } from '../../../value/types';

const getNumberValue: StringValue<{
	fieldId: string;
	type: typeof NUMBER_CF_TYPE | typeof STORY_POINTS_TYPE | typeof STORY_POINT_ESTIMATE_CF_TYPE;
	value: number | null;
}> = (field) => String(field.value || '');

export const numberStringValueHandler = {
	[NUMBER_CF_TYPE]: getNumberValue,
	[STORY_POINTS_TYPE]: getNumberValue,
	[STORY_POINT_ESTIMATE_CF_TYPE]: getNumberValue,
};
